import { delay } from './delay';

export const DELAY_LOADING_SECONDS = 1.5;

export const delayLoadingAnimation = async () =>
  delay(DELAY_LOADING_SECONDS * 1000);
